import React from "react";
import loader from "/assets/spinner.gif";

const Loader = () => {
  return <img className="text-center"  src={ loader } alt="laoding" />;
};

export default Loader;
